import React from 'react';
import classNames from 'classnames';
import { arrayOf, string, shape, number } from 'prop-types';
import { CardMedia, Link } from '~/@one-thd/sui-atomic-components';

export const Thumbnails = React.memo(({ url = '', thumbnails, numberOfThumbnails = 3 }) => {

  const isEmptyList = thumbnails?.length === 0;

  const thumbnailsWrapperClass = classNames(
    'sui-grid sui-gap-2 sui-h-full',
    {
      'sui-grid-cols-1': numberOfThumbnails === 1,
      'sui-grid-cols-2': numberOfThumbnails === 2,
      'sui-grid-cols-3': numberOfThumbnails === 3,
      'sui-grid-cols-4': numberOfThumbnails === 4,
      'sui-grid-cols-5': numberOfThumbnails >= 5,
    }
  );

  const EmptyList = () => {
    return (
      Array.from({ length: numberOfThumbnails }, (__, index) => {
        return (
          <div
            // eslint-disable-next-line tailwindcss/no-arbitrary-value
            className="sui-w-full"
            key={`list-tile-empty-thumbnail-${index}`}
          >
            <div className="sui-w-full sui-bg-strong sui-aspect-square" />
          </div>
        );
      })
    );
  };

  const ThumbnailsElement = () => (
    <div className={thumbnailsWrapperClass}>
      {!isEmptyList ? (
        Array.from({ length: numberOfThumbnails }, (__, thumbnailIndex) => {
          const thumbnailUrl = thumbnails?.length > thumbnailIndex && thumbnails?.[thumbnailIndex]?.url;
          return (
            <div key={`list-tile-thumbnail-${thumbnailIndex}`}>
              {thumbnailUrl ? (
                <CardMedia className="sui-w-full sui-aspect-square" src={thumbnailUrl} alt="Product Image" />
              ) : (
                <div className="sui-w-full sui-bg-strong sui-aspect-square" />
              )}
            </div>
          );
        })
      ) : (
        <EmptyList />
      )}
    </div>
  );

  return (
    <>
      {
        url ? (
          <Link
            className="sui-w-full sui-h-full"
            href={url}
            data-testid="image-list-link"
          >
            <ThumbnailsElement />
          </Link>
        ) : (<ThumbnailsElement />)
      }
    </>
  );
}, (prevProps, nextProps) => {
  return prevProps.url === nextProps.url
         && prevProps.thumbnails === nextProps.thumbnails
         && prevProps.numberOfThumbnails === nextProps.numberOfThumbnails;
});

Thumbnails.displayName = 'ListTileThumbnails';

Thumbnails.propTypes = {
  url: string,
  thumbnails: arrayOf(shape({
    url: string
  })),
  numberOfThumbnails: number
};

Thumbnails.defaultProps = {
  thumbnails: [],
  url: '',
  numberOfThumbnails: 3
};
